/*
 * eb-webinar-form.js — formularios del directo del 11-nov → Klaviyo (API cliente).
 * Contratos C4/C5 del plan 2026-10-17-webinar-28oct; recetas en brief/integraciones-tecnicas.md §9.3 y §10.
 *
 * Auto-montaje (EBW.onReady):
 *   form[data-ebw-form]  mountRegistro: alta + evento Registro en paralelo (4 s) y redirección según
 *                        landingState. Si fallan las dos: error con alternativa y 'ebw_registro_error'.
 *   [data-ebw-apuntada]  mountApuntada: 1 clic con _kx. Sin _kx o con error enseña el mini formulario
 *                        ([data-ebw-mini-box] o [data-ebw-fallback]); data-ebw-apuntada-state en la raíz.
 *                        Guarda _kx en sessionStorage.ebw_kx (lo lee la sala) y lo quita de la barra.
 *                        Con el reloj de QA (?ebw_now=) no manda el evento.
 *   [data-ebw-sticky-cta] mountStickyCta: botón fijo inferior de la landing en móvil.
 *   form[data-ebw-mini]  mountMiniForm: alta + Registro (+ data-ebw-metric si es otra, p. ej. codigo).
 * Textos: data-msg-* en el form sustituyen a MSG; data-ebw-contact, al email de contacto.
 * Eventos DOM: ebw:registro, ebw:mini, ebw:apuntada (resultado en detail).
 *
 * Atribución: solo el alta desde la landing escribe wb1028_* en el perfil. El 1 clic y los mini
 * formularios la llevan en las propiedades del evento: no pisan la fuente de quien ya se apuntó.
 * Nunca source_*; ni email ni nombre en URLs. Sin keepalive por defecto (con preflight CORS algunos
 * navegadores lo rechazan; además se esperan las respuestas antes de redirigir).
 *
 * ES2019, sin dependencias. Necesita eb-webinar-core.js antes (defer en el layout).
 */
(function (root, factory) {
  var api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) {
    root.EBW = Object.assign(root.EBW || {}, api);
    api._bootForm();
  }
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
  'use strict';

  var API_BASE = 'https://a.klaviyo.com/client/';
  var REVISION = '2026-10-15'; // solo si falta en la config (C1 manda)
  var TIMEOUT_MS = 4000;
  var MARK_KEY = 'ebw_reg';
  var CONTACT = 'contact@elena-busto.com';
  var DEFAULT_METRICS = { registro: 'Webinar 28oct Registro' };
  var DEFAULT_UIDS = { registro: 'wb1028-registro' };
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  // Propiedades de perfil permitidas (como wb1028_<clave>).
  var PROFILE_KEYS = ['fuente', 'variante', 'landing', 'registro_iso'].concat(UTM_KEYS);

  var MSG = {
    emailEmpty: 'Escribe tu email para poder mandarte el enlace.',
    emailInvalid: 'Revisa el email: parece que le falta algo.',
    nameEmpty: 'Escribe tu nombre.',
    consent: 'Marca la casilla para poder apuntarte.',
    suggest: '¿Querías decir {email}?',
    busy: 'Reservando…',
    busyMsg: 'Un momento, te estoy apuntando…',
    ok: 'Hecho. Te llevo a la confirmación…',
    okMini: 'Hecho. Ya estás dentro.',
    error:
      'No he podido apuntarte. Revisa que el email esté bien escrito y vuelve a intentarlo. ' +
      'Si sigue sin ir, puede que un bloqueador de anuncios o la conexión lo estén frenando: ' +
      'prueba sin bloqueador o desde otro navegador, o escríbenos a {contacto} y te apuntamos a mano.',
  };

  function warn(where, err) {
    if (root.console && root.console.warn) root.console.warn('[EBW form] ' + where, err);
  }

  // Núcleo: window.EBW en el navegador; el fichero hermano en Node (tests).
  var nodeCore = null;
  function core() {
    if (root.EBW && typeof root.EBW.landingState === 'function') return root.EBW;
    if (!nodeCore && typeof module === 'object' && module.exports && typeof require === 'function') {
      try {
        nodeCore = require('./eb-webinar-core.js');
      } catch (e) {
        nodeCore = {};
      }
    }
    return nodeCore || {};
  }

  function str(v, max) {
    return v == null ? '' : String(v).trim().slice(0, max || 200);
  }

  function isObj(o) {
    return !!o && typeof o === 'object' && !Array.isArray(o);
  }

  // Sin undefined, null ni cadenas vacías (no pisan en Klaviyo un valor que ya existe).
  function clean(obj) {
    var out = {};
    if (!isObj(obj)) return out;
    Object.keys(obj).forEach(function (k) {
      var v = obj[k];
      if (v === undefined || v === null || v === '') return;
      out[k] = typeof v === 'string' ? v.slice(0, 500) : v;
    });
    return out;
  }

  // --- Email ---

  // Dominios habituales (ganan los primeros si empatan), con los legítimos parecidos a otros.
  var KNOWN_DOMAINS = [
    'gmail.com', 'hotmail.com', 'hotmail.es', 'outlook.com', 'outlook.es', 'yahoo.es', 'yahoo.com',
    'icloud.com', 'live.com', 'live.es', 'msn.com', 'me.com', 'mac.com', 'googlemail.com', 'ymail.com',
    'mail.com', 'email.com', 'aol.com', 'gmx.es', 'gmx.com', 'gmx.net', 'protonmail.com', 'proton.me',
    'telefonica.net', 'movistar.es', 'orange.es', 'vodafone.es', 'euskaltel.net', 'hotmail.fr',
    'outlook.fr', 'yahoo.fr', 'hotmail.it', 'yahoo.it', 'yandex.com', 'zoho.com',
  ];
  var LOCAL_RE = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*$/;
  var LABEL_RE = /^[a-z0-9¡-￿](?:[a-z0-9¡-￿-]*[a-z0-9¡-￿])?$/;
  var TLD_RE = /^(?:[a-z¡-￿]{2,63}|xn--[a-z0-9-]{1,59})$/;

  // Distancia de edición con transposiciones (gmial → gmail cuenta 1).
  function editDistance(a, b) {
    var d = [];
    var i;
    var j;
    for (i = 0; i <= a.length; i++) d[i] = [i];
    for (j = 1; j <= b.length; j++) d[0][j] = j;
    for (i = 1; i <= a.length; i++) {
      for (j = 1; j <= b.length; j++) {
        var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        var v = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
        if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) {
          v = Math.min(v, d[i - 2][j - 2] + 1);
        }
        d[i][j] = v;
      }
    }
    return d[a.length][b.length];
  }

  function suggestDomain(domain) {
    if (KNOWN_DOMAINS.indexOf(domain) !== -1) return '';
    var tld = domain.slice(domain.lastIndexOf('.') + 1);
    var name = domain.slice(0, domain.indexOf('.'));
    var best = '';
    var bestDist = Infinity;
    KNOWN_DOMAINS.forEach(function (known) {
      // 2 errores solo si el final (.com, .es…) coincide y el nombre es largo; si no, 1.
      var max = known.slice(known.lastIndexOf('.') + 1) === tld && name.length >= 6 ? 2 : 1;
      var dist = editDistance(domain, known);
      if (dist <= max && dist < bestDist) {
        best = known;
        bestDist = dist;
      }
    });
    return best;
  }

  // {ok:false, error:'vacio'|'formato'} | {ok:true, email, sugerencia?}
  function validEmail(raw) {
    var email = String(raw == null ? '' : raw).trim().toLowerCase();
    if (!email) return { ok: false, error: 'vacio' };
    var bad = { ok: false, error: 'formato' };
    var at = email.lastIndexOf('@');
    if (at < 1 || email.length > 254) return bad;
    var local = email.slice(0, at);
    var domain = email.slice(at + 1);
    if (local.length > 64 || !LOCAL_RE.test(local)) return bad;
    var labels = domain.split('.');
    if (labels.length < 2) return bad;
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].length > 63 || !LABEL_RE.test(labels[i])) return bad;
    }
    if (!TLD_RE.test(labels[labels.length - 1])) return bad;
    var out = { ok: true, email: email };
    var fix = suggestDomain(domain);
    if (fix) out.sugerencia = local + '@' + fix;
    return out;
  }

  // Errata probable (r = validEmail): frena el envío una vez por email. Solo lo llama el submit:
  // el "change" llega justo antes (Enter o clic) y no dice si se ha leído la sugerencia.
  function holdForTypo(st, r) {
    if (!r || !r.ok || !r.sugerencia || st.typoHeld === r.email) return false;
    st.typoHeld = r.email;
    return true;
  }

  // --- Cuerpos de la API cliente (revisión 2026-10-15) ---

  // {fuente, utm_source…} → {wb1028_fuente, wb1028_utm_source…}; wb1028_* pasa, el resto se descarta.
  function profileProps(props) {
    var out = {};
    if (!isObj(props)) return out;
    Object.keys(props).forEach(function (k) {
      var key = k.indexOf('wb1028_') === 0 ? k : PROFILE_KEYS.indexOf(k) !== -1 ? 'wb1028_' + k : '';
      var v = props[k];
      if (!key || v === undefined || v === null || v === '') return;
      out[key] = typeof v === 'string' ? v.slice(0, 200) : v;
    });
    return out;
  }

  // Solo atributos con valor (un first_name vacío no borra el que hay).
  function profileAttrs(profile) {
    var p = profile || {};
    var out = {};
    var kx = str(p._kx, 300);
    var email = str(p.email, 254).toLowerCase();
    var name = str(p.first_name, 60).replace(/\s+/g, ' ');
    if (kx) out._kx = kx;
    if (email) out.email = email;
    if (name) out.first_name = name;
    if (isObj(p.properties) && Object.keys(p.properties).length) out.properties = p.properties;
    return out;
  }

  function buildSubscription(profile, props, cfg) {
    var p = props || {};
    var attrs = profileAttrs({ email: profile && profile.email, first_name: profile && profile.first_name });
    var extra = profileProps(p);
    if (Object.keys(extra).length) attrs.properties = extra;
    attrs.subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: str(p.custom_source, 120) || 'Webinar 28oct · landing ' + (str(p.variante, 60) || 'web'),
          profile: { data: { type: 'profile', attributes: attrs } },
        },
        relationships: { list: { data: { type: 'list', id: String((cfg && cfg.listId) || '') } } },
      },
    };
  }

  function buildEvent(metric, profile, props, uid) {
    var attributes = {
      properties: clean(props),
      metric: { data: { type: 'metric', attributes: { name: String(metric || '') } } },
      profile: { data: { type: 'profile', attributes: profileAttrs(profile) } },
    };
    if (uid) attributes.unique_id = String(uid); // mismo uid + perfil + métrica = un solo evento
    return { data: { type: 'event', attributes: attributes } };
  }

  // POST a la API cliente. Nunca lanza: resuelve {ok, status} (status 0 = red, bloqueador o config).
  function kPost(path, body, cfg, opts) {
    var c = cfg || {};
    var o = opts || {};
    var doFetch = o.fetch || root.fetch;
    if (!c.companyId || typeof doFetch !== 'function') return Promise.resolve({ ok: false, status: 0 });
    var init = {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        Accept: 'application/vnd.api+json',
        revision: c.revision || REVISION,
      },
      body: JSON.stringify(body),
    };
    if (o.keepalive) init.keepalive = true;
    var request;
    try {
      request = doFetch.call(root, API_BASE + path + '?company_id=' + encodeURIComponent(c.companyId), init);
    } catch (e) {
      return Promise.resolve({ ok: false, status: 0 });
    }
    return Promise.resolve(request).then(
      function (res) {
        var status = (res && res.status) || 0;
        return { ok: status >= 200 && status < 300, status: status };
      },
      function () {
        return { ok: false, status: 0 };
      }
    );
  }

  // Espera a todas (kPost no rechaza) o a `ms`; las pendientes quedan en null.
  function settleWithin(promises, ms) {
    return new Promise(function (resolve) {
      var results = promises.map(function () {
        return null;
      });
      var left = promises.length;
      var done = false;
      var timer = null;
      function finish(timedOut) {
        if (done) return;
        done = true;
        if (timer) clearTimeout(timer);
        resolve({ results: results, timedOut: timedOut });
      }
      timer = setTimeout(function () {
        finish(true);
      }, ms);
      promises.forEach(function (p, i) {
        p.then(function (r) {
          results[i] = r;
          left -= 1;
          if (!left) finish(false);
        });
      });
      if (!left) finish(false);
    });
  }

  // Motivo del fallo de las llamadas `idx` (todas si no se indica): timeout | api | red.
  function failReason(settled, idx) {
    var rs = idx
      ? idx.map(function (i) {
          return settled.results[i];
        })
      : settled.results;
    if (settled.timedOut && rs.indexOf(null) !== -1) return 'timeout';
    var anyHttp = rs.some(function (r) {
      return r && r.status > 0;
    });
    return anyHttp ? 'api' : 'red';
  }

  // --- Flujos (puros: todo lo externo llega en deps) ---

  function session() {
    try {
      return root.sessionStorage || null;
    } catch (e) {
      return null;
    }
  }

  function publishAnalytics(name, payload) {
    try {
      var analytics = root.Shopify && root.Shopify.analytics;
      if (analytics && typeof analytics.publish === 'function') analytics.publish(name, payload);
    } catch (e) {
      warn('analytics', e);
    }
  }

  function hasUtm(u) {
    return UTM_KEYS.some(function (k) {
      return !!(u && u[k]);
    });
  }

  // Rellena lo que no venga en deps con el navegador y el núcleo.
  function env(deps) {
    var d = deps || {};
    var C = core();
    var utm = d.utm;
    if (!utm) {
      utm = typeof C.utm === 'function' ? C.utm() : {};
      // Sin sessionStorage (modo privado estricto) las UTMs no se guardaron: se leen de la URL.
      if (!hasUtm(utm) && typeof C.captureUtm === 'function' && root.location && root.location.search) {
        utm = C.captureUtm(null, new URLSearchParams(root.location.search));
      }
    }
    return {
      cfg: d.cfg || (typeof C.config === 'function' ? C.config() : {}),
      fetch: d.fetch,
      storage: 'storage' in d ? d.storage : session(),
      utm: utm || {},
      now: d.now || (typeof C.now === 'function' ? C.now : Date.now),
      landing: d.landing != null ? d.landing : root.location ? root.location.pathname : '',
      publish: d.publish || publishAnalytics,
      navigate: d.navigate,
      klaviyo: 'klaviyo' in d ? d.klaviyo : root.klaviyo,
      timeoutMs: d.timeoutMs || TIMEOUT_MS,
    };
  }

  function metricName(cfg, key) {
    return (cfg.metrics && cfg.metrics[key]) || DEFAULT_METRICS[key] || key;
  }

  function uidFor(cfg, key) {
    return (cfg.uids && cfg.uids[key]) || DEFAULT_UIDS[key] || '';
  }

  // Acepta la clave ("codigo") o el nombre de la métrica ("Webinar 28oct Codigo").
  function resolveMetric(cfg, metricOrKey, uid) {
    var c = cfg || {};
    var metrics = c.metrics || {};
    var key = metricOrKey || 'registro';
    if (!metrics[key] && !DEFAULT_METRICS[key]) {
      key =
        Object.keys(metrics).filter(function (k) {
          return metrics[k] === metricOrKey;
        })[0] || '';
    }
    return {
      metric: key ? metricName(c, key) : String(metricOrKey),
      uid: uid || (key ? uidFor(c, key) : ''),
    };
  }

  function utmProps(utm) {
    var out = {};
    UTM_KEYS.forEach(function (k) {
      out[k] = str(utm && utm[k]);
    });
    return out;
  }

  function fuenteFrom(utm) {
    var C = core();
    return typeof C.resolveFuente === 'function' ? C.resolveFuente(utm) : 'organico';
  }

  function identify(klaviyo, profile) {
    // Enlaza la cookie de klaviyo.js con el perfil: la sala lo usa luego (klaviyo.isIdentified()).
    try {
      if (!klaviyo || typeof klaviyo.identify !== 'function') return;
      var data = { email: profile.email };
      if (profile.first_name) data.first_name = profile.first_name;
      var r = klaviyo.identify(data);
      if (r && typeof r.catch === 'function') r.catch(function () {});
    } catch (e) {
      warn('identify', e);
    }
  }

  function redirectFor(state, cfg) {
    var urls = (cfg && cfg.urls) || {};
    var gracias = urls.gracias || '/pages/webinar-gracias';
    if (state === 'ultima-hora' || state === 'en-directo') return urls.directo || '/pages/webinar-directo';
    if (state === 'grabacion') return gracias + (gracias.indexOf('?') === -1 ? '?' : '&') + 'modo=grabacion';
    return gracias; // abierto (y cerrado, que no enseña formulario)
  }

  // Registro desde la landing. input = {email, first_name, variante}.
  // → {ok:true, redirect, state, subscribed, tracked} | {ok:false, reason:'config'|'red'|'api'|'timeout'}
  function submitRegistro(input, deps) {
    var e = env(deps);
    var cfg = e.cfg;
    var variante = str(input && input.variante, 60) || 'sin-variante';
    function fail(reason) {
      e.publish('ebw_registro_error', { variante: variante, motivo: reason });
      return { ok: false, reason: reason };
    }
    if (!cfg.listId || !cfg.companyId) {
      warn('config', 'falta listId o companyId en #ebw-config');
      return Promise.resolve(fail('config'));
    }
    var C = core();
    var state = typeof C.landingState === 'function' ? C.landingState(e.now(), cfg) : 'abierto';
    var fuente = fuenteFrom(e.utm);
    var utm = utmProps(e.utm);
    var base = Object.assign({ fuente: fuente, variante: variante, landing: e.landing }, utm);
    var perfil = profileProps(Object.assign({ registro_iso: new Date().toISOString() }, base));
    var profile = { email: input.email, first_name: input.first_name };
    var eventProps = Object.assign({}, base, {
      estado: state,
      has_fbclid: !!e.utm.has_fbclid,
      has_gclid: !!e.utm.has_gclid,
    });
    var calls = [
      kPost('subscriptions', buildSubscription(profile, Object.assign({ registro_iso: perfil.wb1028_registro_iso }, base), cfg), cfg, { fetch: e.fetch }),
      kPost(
        'events',
        buildEvent(metricName(cfg, 'registro'), Object.assign({ properties: perfil }, profile), eventProps, uidFor(cfg, 'registro')),
        cfg,
        { fetch: e.fetch }
      ),
    ];
    return settleWithin(calls, e.timeoutMs).then(function (settled) {
      var subscribed = !!(settled.results[0] && settled.results[0].ok);
      var tracked = !!(settled.results[1] && settled.results[1].ok);
      if (!subscribed && !tracked) return fail(failReason(settled));
      if (!subscribed || !tracked) {
        warn('registro parcial', { suscripcion: settled.results[0], evento: settled.results[1] });
      }
      var url = redirectFor(state, cfg);
      try {
        // Marca anti-recarga: la gracias (o la sala) publica 'ebw_registro' una vez y la borra.
        if (e.storage) e.storage.setItem(MARK_KEY, JSON.stringify({ v: variante, t: Date.now() }));
      } catch (err) {
        /* sin almacenamiento: no habrá evento de conversión, pero el registro está hecho */
      }
      identify(e.klaviyo, profile);
      if (typeof e.navigate === 'function') e.navigate(url);
      return { ok: true, redirect: url, state: state, subscribed: subscribed, tracked: tracked };
    });
  }

  // Mini formulario: alta + Registro, y además opts.metric si es otra (p. ej. Codigo en la sala).
  // input = {email, first_name, variante}; opts = {metric, uid, props}.
  // ok: con Registro, basta que entre el alta o el evento; con otra métrica, tiene que entrar esa.
  // El alta no lleva wb1028_*: quien ya se apuntó por un anuncio y entra desde otro dispositivo
  // conserva su atribución. Fuente, variante, landing y UTM viajan en los eventos.
  function submitMini(input, deps, opts) {
    var e = env(deps);
    var o = opts || {};
    var cfg = e.cfg;
    var variante = str(input && input.variante, 60) || 'mini';
    function fail(reason) {
      e.publish('ebw_registro_error', { variante: variante, motivo: reason });
      return { ok: false, reason: reason };
    }
    if (!cfg.listId || !cfg.companyId) {
      warn('config', 'falta listId o companyId en #ebw-config');
      return Promise.resolve(fail('config'));
    }
    var registro = resolveMetric(cfg, 'registro');
    var main = resolveMetric(cfg, o.metric || 'registro', o.uid);
    var base = Object.assign({ fuente: fuenteFrom(e.utm), variante: variante, landing: e.landing }, utmProps(e.utm));
    var profile = { email: input.email, first_name: input.first_name };
    var sub = buildSubscription(profile, { custom_source: 'Webinar 28oct · mini ' + variante }, cfg);
    var calls = [
      kPost('subscriptions', sub, cfg, { fetch: e.fetch }),
      kPost('events', buildEvent(registro.metric, profile, base, registro.uid), cfg, { fetch: e.fetch }),
    ];
    var extra = main.metric !== registro.metric;
    if (extra) {
      calls.push(
        kPost('events', buildEvent(main.metric, profile, Object.assign({}, base, clean(o.props)), main.uid), cfg, { fetch: e.fetch })
      );
    }
    return settleWithin(calls, e.timeoutMs).then(function (settled) {
      var r = settled.results;
      var registered = !!((r[0] && r[0].ok) || (r[1] && r[1].ok));
      if (!registered) return fail(failReason(settled, [0, 1]));
      if (extra && !(r[2] && r[2].ok)) {
        // El alta entró: no cuenta como error de registro.
        var reason = failReason(settled, [2]);
        e.publish('ebw_evento_error', { variante: variante, motivo: reason, metrica: main.metric });
        return { ok: false, reason: reason };
      }
      identify(e.klaviyo, profile);
      return { ok: true, subscribed: !!(r[0] && r[0].ok), tracked: !!(r[1] && r[1].ok) };
    });
  }

  // _kx de la query string sin convertir "+" en espacio. Solo caracteres de un id de Klaviyo.
  function readKx(search) {
    var m = /(?:^|[?&])_kx=([^&#]*)/.exec(String(search || ''));
    if (!m) return '';
    var v;
    try {
      v = decodeURIComponent(m[1]).trim();
    } catch (e) {
      return '';
    }
    return v.length <= 300 && /^[A-Za-z0-9._~=+/-]+$/.test(v) ? v : '';
  }

  // 1 clic: mismo evento y unique_id que el formulario, identificado por _kx.
  function sendOneClick(kx, deps) {
    if (!kx) return Promise.resolve({ ok: false, reason: 'sin-kx' });
    var e = env(deps);
    var cfg = e.cfg;
    var props = Object.assign({ fuente: 'email_1clic', variante: '1clic', landing: e.landing }, utmProps(e.utm));
    var body = buildEvent(metricName(cfg, 'registro'), { _kx: kx }, props, uidFor(cfg, 'registro'));
    return settleWithin([kPost('events', body, cfg, { fetch: e.fetch })], e.timeoutMs).then(function (settled) {
      var r = settled.results[0];
      return r && r.ok ? { ok: true } : { ok: false, reason: failReason(settled) };
    });
  }

  // 'ebw_registro' una vez por alta (marca del formulario). Si la marca no se puede borrar, no se
  // publica (se repetiría en cada recarga); una marca que no es JSON se publica sin variante.
  function takeRegistroMark(storage, publish) {
    var raw = null;
    try {
      raw = storage && storage.getItem(MARK_KEY);
      if (!raw) return false;
      storage.removeItem(MARK_KEY);
      if (storage.getItem(MARK_KEY) !== null) return false;
    } catch (e) {
      return false;
    }
    var variante = '';
    try {
      var mark = JSON.parse(raw);
      if (isObj(mark)) variante = str(mark.v, 60);
    } catch (e) {
      /* marca rota: se publica sin variante */
    }
    try {
      (publish || publishAnalytics)('ebw_registro', { variante: variante });
    } catch (e) {
      warn('ebw_registro', e);
    }
    return true;
  }

  // --- DOM ---

  var doc = root.document;
  var uidCounter = 0;

  function qsa(scope, selector) {
    var base = scope && scope.querySelectorAll ? scope : doc;
    var list = Array.prototype.slice.call(base.querySelectorAll(selector));
    if (base.matches && base.matches(selector)) list.unshift(base);
    return list;
  }

  function dispatch(target, name, detail) {
    try {
      target.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
    } catch (e) {
      warn(name, e);
    }
  }

  function formId(form) {
    if (!form.id) form.id = 'ebw-form-' + ++uidCounter;
    return form.id;
  }

  function tokens(el, attr, id, on) {
    var list = (el.getAttribute(attr) || '').split(/\s+/).filter(Boolean);
    var at = list.indexOf(id);
    if (on && at === -1) list.push(id);
    if (!on && at !== -1) list.splice(at, 1);
    if (list.length) el.setAttribute(attr, list.join(' '));
    else el.removeAttribute(attr);
  }

  function messages(form) {
    var out = {};
    Object.keys(MSG).forEach(function (k) {
      var attr = 'data-msg-' + k.replace(/[A-Z]/g, function (c) {
        return '-' + c.toLowerCase();
      });
      out[k] = form.getAttribute(attr) || MSG[k];
    });
    return out;
  }

  function fields(form) {
    return {
      name: form.querySelector('[name="first_name"]'),
      email: form.querySelector('[name="email"]'),
      consent: form.querySelector('[name="consent"]'),
      submit: form.querySelector('[type="submit"]'),
      hp: form.querySelector('.ebw-hp input, input[data-ebw-hp], [data-ebw-hp] input'),
    };
  }

  // [data-ebw-error|hint="<campo>"]: si no están, se crean tras el campo (o su .ebw-check),
  // en orden campo → error → sugerencia.
  function slot(form, input, kind) {
    var el = form.querySelector('[data-ebw-' + kind + '="' + input.name + '"]');
    if (!el) {
      el = doc.createElement('span');
      el.className = kind === 'error' ? 'ebw-field__error' : 'ebw-field__hint';
      el.hidden = true;
      el.setAttribute('data-ebw-' + kind, input.name);
      var after = input.type === 'checkbox' ? input.closest('.ebw-check') || input.closest('label') || input : input;
      var next = after.nextElementSibling;
      if (kind === 'hint' && next && next.getAttribute('data-ebw-error') === input.name) after = next;
      after.insertAdjacentElement('afterend', el);
    }
    if (!el.id) el.id = (input.id || formId(form) + '-' + input.name) + '-' + kind;
    if (kind === 'hint') el.setAttribute('aria-live', 'polite');
    return el;
  }

  function setFieldError(form, input, text) {
    if (!input) return;
    var el = slot(form, input, 'error');
    el.textContent = text || '';
    el.hidden = !text;
    if (text) tokens(input, 'aria-describedby', el.id, true); // vacío no se lee: el enlace se queda
    if (text) input.setAttribute('aria-invalid', 'true');
    else input.removeAttribute('aria-invalid');
  }

  var LINK_BUTTON_STYLE =
    'font:inherit;color:var(--ebw-link,inherit);background:none;border:0;margin:0;padding:.2em 0;' +
    'text-decoration:underline;text-underline-offset:3px;cursor:pointer;';

  function setSuggestion(form, input, suggestion, msgs) {
    var el = slot(form, input, 'hint');
    // Misma sugerencia ya visible: no se rehace (el botón podría estar bajo el puntero).
    if (suggestion && !el.hidden && el.__ebwSuggestion === suggestion) return;
    el.__ebwSuggestion = suggestion || '';
    el.textContent = '';
    tokens(input, 'aria-describedby', el.id, !!suggestion);
    el.hidden = !suggestion;
    if (!suggestion) return;
    var parts = msgs.suggest.split('{email}');
    var button = doc.createElement('button');
    button.type = 'button';
    button.textContent = suggestion;
    button.style.cssText = LINK_BUTTON_STYLE;
    button.addEventListener('click', function () {
      input.value = suggestion;
      setSuggestion(form, input, '', msgs);
      setFieldError(form, input, '');
      input.focus();
    });
    el.appendChild(doc.createTextNode(parts[0]));
    el.appendChild(button);
    el.appendChild(doc.createTextNode(parts.slice(1).join('')));
  }

  function msgElement(form) {
    var el = form.querySelector('[data-ebw-form-msg]');
    if (!el) {
      el = doc.createElement('p');
      el.className = 'ebw-form-msg';
      el.setAttribute('role', 'status');
      el.setAttribute('data-ebw-form-msg', '');
      form.appendChild(el);
    }
    return el;
  }

  function setMsg(el, kind, content) {
    el.classList.toggle('is-error', kind === 'error');
    el.classList.toggle('is-ok', kind === 'ok');
    el.textContent = '';
    if (typeof content === 'string') el.textContent = content;
    else if (content) {
      content.forEach(function (node) {
        el.appendChild(node);
      });
    }
  }

  function errorContent(form, msgs) {
    var contact = form.getAttribute('data-ebw-contact') || CONTACT;
    var parts = msgs.error.split('{contacto}');
    var nodes = [doc.createTextNode(parts[0])];
    if (parts.length > 1) {
      var a = doc.createElement('a');
      a.href = 'mailto:' + contact;
      a.textContent = contact;
      nodes.push(a, doc.createTextNode(parts.slice(1).join('')));
    }
    return nodes;
  }

  function setBusy(form, button, busy, label) {
    form.setAttribute('aria-busy', busy ? 'true' : 'false');
    if (!button) return;
    // aria-disabled y no disabled: el botón no pierde el foco mientras se envía.
    if (busy) {
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
    }
    // El texto lleva un <span> por estado de la landing: se oculta entero y se añade otro al lado.
    var text = button.querySelector('[data-ebw-btn-label]') || button.querySelector('.ebw-btn__label');
    if (!text) return;
    var busyText = button.querySelector('[data-ebw-busy-text]');
    if (busy) {
      if (!busyText) {
        busyText = doc.createElement('span');
        busyText.className = 'ebw-btn__label';
        busyText.setAttribute('data-ebw-busy-text', '');
        text.insertAdjacentElement('afterend', busyText);
      }
      busyText.textContent = button.getAttribute('data-busy-label') || label;
      text.hidden = true;
    } else {
      if (busyText) busyText.remove();
      text.hidden = false;
    }
  }

  // Valida el formulario y pinta los errores. Devuelve {ok, email, name, focus}.
  function validate(form, f, msgs, st) {
    var firstBad = null;
    var email = '';
    var name = f.name ? str(f.name.value, 60).replace(/\s+/g, ' ') : '';

    if (f.name) {
      var nameBad = f.name.required && !name;
      setFieldError(form, f.name, nameBad ? msgs.nameEmpty : '');
      if (nameBad) firstBad = firstBad || f.name;
    }

    if (f.email) {
      var r = validEmail(f.email.value);
      setFieldError(form, f.email, r.ok ? '' : r.error === 'vacio' ? msgs.emailEmpty : msgs.emailInvalid);
      if (!r.ok) {
        setSuggestion(form, f.email, '', msgs);
        firstBad = firstBad || f.email;
      } else {
        email = r.email;
        if (holdForTypo(st, r)) {
          setSuggestion(form, f.email, r.sugerencia, msgs);
          firstBad = firstBad || f.email;
        }
      }
    } else {
      firstBad = form;
    }

    if (f.consent) {
      setFieldError(form, f.consent, f.consent.checked ? '' : msgs.consent);
      if (!f.consent.checked) firstBad = firstBad || f.consent;
    }

    return { ok: !firstBad, email: email, name: name, focus: firstBad };
  }

  // Al salir del campo con un clic, el "change" llega en el mousedown: si la sugerencia se pintara
  // ahí, lo de debajo bajaría y el clic caería fuera. afterPress(fn) espera al final del clic.
  var press = null;
  function trackPress() {
    if (press) return;
    press = { on: false, timer: 0, queue: [] };
    function end() {
      if (!press.on) return;
      press.on = false;
      clearTimeout(press.timer);
      press.queue.splice(0).forEach(function (fn) {
        try {
          fn();
        } catch (e) {
          warn('afterPress', e);
        }
      });
    }
    function start() {
      press.on = true;
      clearTimeout(press.timer);
      press.timer = setTimeout(end, 1500); // por si no llega el click (arrastre, pulsación larga)
    }
    doc.addEventListener('pointerdown', start, true);
    doc.addEventListener('mousedown', start, true);
    doc.addEventListener('pointercancel', end, true);
    root.addEventListener('click', function () {
      setTimeout(end, 0);
    });
  }

  function afterPress(fn) {
    if (press && press.on) press.queue.push(fn);
    else fn();
  }

  function wireFields(form, f, msgs) {
    if (f.email) {
      trackPress();
      f.email.addEventListener('input', function () {
        setFieldError(form, f.email, '');
        setSuggestion(form, f.email, '', msgs);
      });
      // Al salir del campo se avisa de la errata, sin frenar (eso lo decide el submit).
      f.email.addEventListener('change', function () {
        afterPress(function () {
          var r = validEmail(f.email.value);
          setSuggestion(form, f.email, r.ok && r.sugerencia ? r.sugerencia : '', msgs);
        });
      });
    }
    if (f.name) {
      f.name.addEventListener('input', function () {
        setFieldError(form, f.name, '');
      });
    }
    if (f.consent) {
      f.consent.addEventListener('change', function () {
        if (f.consent.checked) setFieldError(form, f.consent, '');
      });
    }
  }

  // Monta el envío común: validación accesible, estado "enviando", un solo envío a la vez.
  // send(data) → Promise<{ok}>; done(result) se llama con el resultado.
  function wireForm(form, send, done) {
    var C = core();
    var f = fields(form);
    var msgs = messages(form);
    var msgEl = msgElement(form);
    var st = { sending: false, typoHeld: '' };
    form.noValidate = true; // mensajes propios accesibles en vez de los globos del navegador
    wireFields(form, f, msgs);

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (st.sending || form.hasAttribute('data-ebw-done')) return;
      if (f.hp && f.hp.value) return; // trampa para bots: no se envía nada
      var v = validate(form, f, msgs, st);
      if (!v.ok) {
        if (v.focus && v.focus !== form && typeof v.focus.focus === 'function') v.focus.focus();
        return;
      }
      st.sending = true;
      setBusy(form, f.submit, true, msgs.busy);
      setMsg(msgEl, '', msgs.busyMsg);
      var cfg = typeof C.config === 'function' ? C.config() : {};
      send({ email: v.email, first_name: v.name }, cfg, msgs, msgEl)
        .catch(function (err) {
          warn('envío', err);
          return { ok: false, reason: 'js' };
        })
        .then(function (result) {
          if (!result.ok || !result.navigating) {
            st.sending = false;
            setBusy(form, f.submit, false);
          }
          if (!result.ok) setMsg(msgEl, 'error', errorContent(form, msgs));
          done(result, f, msgs, msgEl);
        });
    });

    // Volver atrás desde la gracias (bfcache): el formulario no se queda "Reservando…".
    root.addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;
      st.sending = false;
      setBusy(form, f.submit, false);
      setMsg(msgEl, '', '');
    });
  }

  function mountRegistro(form) {
    if (!form || form.__ebwForm) return;
    form.__ebwForm = true;
    wireForm(
      form,
      function (data, cfg, msgs, msgEl) {
        return submitRegistro(
          { email: data.email, first_name: data.first_name, variante: form.getAttribute('data-ebw-variant') || '' },
          {
            cfg: cfg,
            navigate: function (url) {
              setMsg(msgEl, 'ok', msgs.ok);
              root.location.assign(url);
            },
          }
        ).then(function (r) {
          return Object.assign({ navigating: r.ok }, r);
        });
      },
      function (result) {
        dispatch(form, 'ebw:registro', result);
      }
    );
  }

  function markDone(form, f) {
    form.setAttribute('data-ebw-done', '');
    [f.name, f.email, f.consent].forEach(function (input) {
      if (input) input.readOnly = true;
    });
    if (f.consent) f.consent.disabled = true; // readOnly no aplica a casillas
    if (f.submit) f.submit.setAttribute('aria-disabled', 'true');
  }

  // opts = {metric (clave o nombre), uid, props, variante, onDone}. Si ya está montado, se
  // actualizan las opciones (la sala puede pasar onDone después del auto-montaje).
  function mountMiniForm(form, opts) {
    if (!form) return;
    if (form.__ebwMini) {
      Object.assign(form.__ebwMini, opts || {});
      return;
    }
    var state = Object.assign({}, opts || {});
    form.__ebwMini = state;
    wireForm(
      form,
      function (data, cfg) {
        var metric = state.metric || form.getAttribute('data-ebw-metric') || 'registro';
        var m = resolveMetric(cfg, metric, state.uid);
        return submitMini(
          {
            email: data.email,
            first_name: data.first_name,
            variante: state.variante || form.getAttribute('data-ebw-variant') || 'mini',
          },
          { cfg: cfg },
          { metric: m.metric, uid: m.uid, props: state.props }
        );
      },
      function (result, f, msgs, msgEl) {
        if (result.ok) {
          setMsg(msgEl, 'ok', msgs.okMini);
          markDone(form, f);
        }
        dispatch(form, 'ebw:mini', result);
        if (result.ok && typeof state.onDone === 'function') {
          try {
            state.onDone(result);
          } catch (e) {
            warn('onDone', e);
          }
        }
      }
    );
  }

  // Quita _kx de la barra: si alguien reenvía la URL, no identifica a otra persona.
  function stripKx() {
    var loc = root.location;
    var h = root.history;
    if (!loc || !h || typeof h.replaceState !== 'function') return;
    var q = String(loc.search || '')
      .replace(/^\?/, '')
      .split('&')
      .filter(function (part) {
        return part && !/^_kx(?:=|$)/.test(part);
      })
      .join('&');
    try {
      h.replaceState(h.state, '', loc.pathname + (q ? '?' + q : '') + (loc.hash || ''));
    } catch (e) {}
  }

  // Botón fijo inferior de la landing (móvil): visible solo mientras el botón de envío, la llamada
  // final y el pie están fuera de pantalla. Al pulsarlo, baja al formulario y da foco al email.
  function mountStickyCta(bar) {
    if (!bar || bar.__ebwSticky) return;
    bar.__ebwSticky = true;
    var form = doc.querySelector('form[data-ebw-form]');
    var submit = form && form.querySelector('[type="submit"]');
    if (!submit || !('IntersectionObserver' in root)) return;
    var watched = [submit, doc.querySelector('.ebw-reg__final'), doc.querySelector('.ebw-footer')].filter(Boolean);
    var seen = watched.map(function () {
      return false;
    });
    var link = bar.querySelector('[data-ebw-sticky-link]');
    function update() {
      var show = !seen.some(Boolean) && !form.hasAttribute('data-ebw-done');
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (link) {
        if (show) link.removeAttribute('tabindex');
        else link.setAttribute('tabindex', '-1');
      }
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var i = watched.indexOf(entry.target);
        if (i !== -1) seen[i] = entry.isIntersecting;
      });
      update();
    });
    watched.forEach(function (el) {
      io.observe(el);
    });
    if (link) {
      link.addEventListener('click', function (ev) {
        var email = form.querySelector('input[type="email"]');
        var target = doc.getElementById((link.getAttribute('href') || '').slice(1)) || form;
        ev.preventDefault();
        var reduce = root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches;
        try {
          target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        } catch (e) {
          target.scrollIntoView();
        }
        if (email) {
          try {
            email.focus({ preventScroll: true });
          } catch (e) {
            email.focus();
          }
        }
      });
    }
  }

  function mountApuntada(box) {
    if (!box || box.__ebwApuntada) return;
    box.__ebwApuntada = true;
    var mini = box.querySelector('form[data-ebw-mini]');
    var fallback = box.querySelector('[data-ebw-mini-box], [data-ebw-fallback]') || mini;
    function showFallback(on) {
      if (fallback) fallback.hidden = !on;
    }
    function setState(s) {
      box.setAttribute('data-ebw-apuntada-state', s);
      dispatch(box, 'ebw:apuntada', { state: s });
    }
    if (mini) {
      mountMiniForm(mini, {
        metric: 'registro',
        variante: mini.getAttribute('data-ebw-variant') || 'apuntada',
        onDone: function () {
          setState('ok');
        },
      });
    }
    var kx = readKx(root.location && root.location.search);
    if (!kx) {
      showFallback(true);
      setState('sin-kx');
      return;
    }
    // La sala lee la misma clave: quien llega por el 1 clic entra identificada.
    var store = session();
    try {
      if (store) store.setItem('ebw_kx', kx);
    } catch (e) {}
    setTimeout(stripKx, 1000); // klaviyo.js también lee _kx de la URL al cargar
    showFallback(false);
    // Reloj de QA (?ebw_now=): nunca se manda el evento real a Klaviyo.
    var C = core();
    if (typeof C.isQaClock === 'function' && C.isQaClock()) {
      warn('1 clic', 'QA (ebw_now): evento no enviado');
      setState('ok');
      return;
    }
    setState('enviando');
    sendOneClick(kx, {}).then(function (r) {
      if (r.ok) {
        setState('ok');
        return;
      }
      showFallback(true);
      setState('error');
    });
  }

  function safely(fn) {
    return function (el) {
      try {
        fn(el);
      } catch (e) {
        warn('mount', e);
      }
    };
  }

  function mountForms(scope) {
    qsa(scope, 'form[data-ebw-form]').forEach(safely(mountRegistro));
    qsa(scope, '[data-ebw-apuntada]').forEach(safely(mountApuntada));
    qsa(scope, '[data-ebw-sticky-cta]').forEach(safely(mountStickyCta));
    qsa(scope, 'form[data-ebw-mini]').forEach(
      safely(function (form) {
        mountMiniForm(form);
      })
    );
  }

  // Shopify.analytics puede tardar: hasta ~10 s. Si no llega, la marca no se gasta.
  function whenAnalytics(fn) {
    var tries = 0;
    (function check() {
      var a = root.Shopify && root.Shopify.analytics;
      if (a && typeof a.publish === 'function') fn();
      else if (tries++ < 40) setTimeout(check, 250);
    })();
  }

  // Las altas de "última hora"/"en directo" van a la sala sin pasar por la gracias: la
  // conversión ('ebw_registro') se publica aquí.
  function publishInRoom() {
    var C = core();
    var cfg = typeof C.config === 'function' ? C.config() : {};
    var directo = (cfg.urls && cfg.urls.directo) || '/pages/webinar-directo';
    var path = (root.location && root.location.pathname.replace(/\/+$/, '')) || '';
    var inRoom = !!doc.querySelector('[data-ebw-room]') || path.slice(-directo.length) === directo;
    if (!inRoom) return;
    whenAnalytics(function () {
      takeRegistroMark(session());
    });
  }

  function bootForm() {
    var C = core();
    if (typeof C.onReady !== 'function' || typeof C.config !== 'function') {
      // Sin núcleo no hay registro: que el form no viaje (email en la URL) y que se vea la alternativa.
      warn('core', 'eb-webinar-core.js no está cargado');
      var block = function () {
        qsa(doc, 'form[data-ebw-form], form[data-ebw-mini]').forEach(function (form) {
          form.addEventListener('submit', function (ev) {
            ev.preventDefault();
            setMsg(msgElement(form), 'error', errorContent(form, messages(form)));
          });
        });
      };
      if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', block);
      else block();
      return;
    }
    C.onReady(function () {
      mountForms(doc);
      publishInRoom();
    });
    // Editor de temas: al recargar una sección, se monta solo lo nuevo.
    doc.addEventListener('shopify:section:load', function (ev) {
      mountForms(ev.target);
    });
  }

  return {
    // Klaviyo (C4)
    klaviyo: {
      post: function (path, body, opts) {
        var C = core();
        return kPost(path, body, typeof C.config === 'function' ? C.config() : {}, opts);
      },
      subscribe: function (profile, props, opts) {
        var C = core();
        var cfg = typeof C.config === 'function' ? C.config() : {};
        if (!cfg.listId || !profile || !profile.email) return Promise.resolve({ ok: false, status: 0 });
        return kPost('subscriptions', buildSubscription(profile, props, cfg), cfg, opts);
      },
      event: function (metric, profile, props, uid, opts) {
        var C = core();
        var cfg = typeof C.config === 'function' ? C.config() : {};
        var m = resolveMetric(cfg, metric, uid);
        return kPost('events', buildEvent(m.metric, profile, props, m.uid), cfg, opts);
      },
    },
    // puras
    validEmail: validEmail,
    holdForTypo: holdForTypo,
    buildSubscription: buildSubscription,
    buildEvent: buildEvent,
    kPost: kPost,
    submitRegistro: submitRegistro,
    submitMini: submitMini,
    sendOneClick: sendOneClick,
    readKx: readKx,
    redirectFor: redirectFor,
    takeRegistroMark: takeRegistroMark,
    // DOM
    mountRegistro: mountRegistro,
    mountApuntada: mountApuntada,
    mountStickyCta: mountStickyCta,
    mountMiniForm: mountMiniForm,
    mountForms: mountForms,
    _bootForm: bootForm,
  };
});
